export default "__VITE_ASSET__BKSc0xoD__"